/* global BigInt */

const MONEY_RE = /^([+-]?)(\d+)(?:[.,](\d{1,2}))?$/;

const toMinor = (value, {allowNegative = false} = {}) => {
    const compact = String(value ?? "").trim().replace(/\s+/g, "");
    const match = compact.match(MONEY_RE);
    if (!match) throw new Error("Некорректная сумма");
    const negative = match[1] === "-";
    if (negative && !allowNegative) throw new Error("Сумма должна быть положительной");
    const minor = BigInt(match[2]) * 100n + BigInt((match[3] || "").padEnd(2, "0"));
    return negative ? -minor : minor;
};

const fromMinor = (minor) => {
    const negative = minor < 0n;
    const absolute = negative ? -minor : minor;
    return `${negative ? "-" : ""}${absolute / 100n}.${String(absolute % 100n).padStart(2, "0")}`;
};

const toSignedMinor = (value) => toMinor(value, {allowNegative: true});

export const normalizeMoney = (value, options) => fromMinor(toMinor(value, options));

export const addMoney = (values) =>
    fromMinor((values || []).reduce((total, value) => total + toSignedMinor(value), 0n));

export const subtractMoney = (left, right) =>
    fromMinor(toSignedMinor(left) - toSignedMinor(right));

export const compareMoney = (left, right) => {
    const difference = toSignedMinor(left) - toSignedMinor(right);
    return difference === 0n ? 0 : difference > 0n ? 1 : -1;
};

export const formatExactMoney = (value, currency) => {
    const normalized = fromMinor(toSignedMinor(value));
    const [integer, fraction] = normalized.replace("-", "").split(".");
    const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return `${normalized.startsWith("-") ? "-" : ""}${grouped}.${fraction}${currency ? ` ${currency}` : ""}`;
};
